import React from 'react';

// DEPENDENCIES
import { useFormikContext } from 'formik';

// GLOBAL PARTS
import Card from 'parts/card/Card';

// LOCAL COMPONENTS
import DownPaymentTable from './parts/DownPaymentTable';

// MAIN COMPONENT
const DownPayment = props => {
  
  // FORMIK CONTEXT
  const { values } = useFormikContext() || {};

  // RENDER
  return values && values.wholesale_format_id && values.wholesale_format_id === '1' ? null : (
    <Card title="Down Payment / Deposit" body={<DownPaymentTable {...props} />} />
  );
}

export default DownPayment;
